import Vue from 'vue'
import Router from 'vue-router'
// import { stringifyQuery, parseQuery } from '../utils/query' //路径位置根据实际修改
// const router = createRouter({
//   history: createWebHashHistory(),
//   stringifyQuery, // 序列化query参数
//   parseQuery, // 反序列化query参数
//   routes,
// })

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home/showHome.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/home/showHome.vue'),
    },
    {
      path: '/navList',
      name: 'navList',
      component: () => import('../views/home/navList.vue'),
    },
    {
      path: '/navItemModel',
      name: 'navItemModel',
      component: () => import('../views/navContext/navItemModel.vue'),
    },
    {
      path: '/newModel',
      name: 'newModel',
      component: () => import('../views/news/newModel1.vue'),
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: () => import('../views/news/newDetail.vue'),
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('../views/teacher/teacherModel.vue'),
    },
    {
      path: '/teacherDetail',
      name: 'teacherDetail',
      component: () => import('../views/teacher/teacherDetail.vue'),
    },
    {
      path: '/detailsModel1/:detailId/:name/:type',
      name: 'detailsModel1',
      component: () => import('../views/navContext/detailModel_1.vue'),
    },
    {
      path: '/studentResources',
      name: 'studentResources',
      component: () => import('../views/studentResources/index.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/index.vue'),
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/search/index.vue'),
    }
  ],
  // stringifyQuery, // 序列化query参数
  // parseQuery, // 反序列化query参数
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else if (to.hash) {
  //     const shouldScroll = localStorage.getItem('shouldScroll'); // 从 localStorage 中获取标志
  //     if (shouldScroll) {
  //       const targetElement = document.querySelector(to.hash);
  //       if (targetElement) {
  //         const yOffset = 0;
  //         setTimeout(() => {
  //           window.scrollTo({
  //             top: targetElement.offsetTop - yOffset,
  //             behavior: 'smooth'
  //           });
  //         }, 200);
  //       }
  //     }
  //     localStorage.removeItem('shouldScroll'); // 滚动后移除标志
  //   }
  //   return { x: 0, y: 0 };
  // }
})
router.beforeEach((to, from, next) => {
  console.log(to, from , '路由拦截');
  const token = sessionStorage.getItem('studentToken'); // 假设 token 存储在 localStorage 中
  if (to.path === '/studentResources' && !token) {
    // 如果没有 token，则重定向到登录页面
    next({
      path: '/login'
    });
  } else {
    // 如果有 token 或访问的不是 /studentResources，则正常导航
    next();
  }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js